/* global modForm Modalytics */
import {
	getFormData,
	getFormsServiceApiDomain,
	mapDynamicServiceCode,
	mapServiceSpecificAttributes,
	modifyTcpaForExclusiveVendors,
	updateConsentHiddenFields
} from '../../helpers';
/**
 * Submit trade-specific answers to HS Forms Service to get Consent Vendor Listings
 * @param {function} callback - Allows us to run a callback function & grab the response
 */
export function getConsentListing(callback) {
	modForm.opts.gettingLiveConsent = true;

	const apiDomain = getFormsServiceApiDomain(),
		apiUrl = apiDomain + 'forms/consent-searches',
		formData = getFormData(),
		activeExp = {};

	let isExclusiveMatch = false;

	const lowerCasedQuadLinkData = Object.fromEntries(
		Object.entries(modForm.opts.quadLinkParams).map(([key, value]) => [key.toLowerCase(), value])
	);

	const quadLinkData = modForm.opts.quadLinkData.quadlink ? { 'quadLink': modForm.opts.quadLinkData.quadlink } : lowerCasedQuadLinkData,
		service = mapDynamicServiceCode(formData),
		partnerSourceID = formData.PartnerSourceID ? { partnerSourceID: formData.PartnerSourceID } : {};

	mapServiceSpecificAttributes(service);

	if (window.activeCampaignData) {
		activeExp.testId = window.activeCampaignData['Test ID'];
		activeExp.variationName = window.activeCampaignData['Variation Name'];
	}

	const consentSearchData = {
		'zip': modForm.opts.getVars.zip ? modForm.opts.getVars.zip : modForm.opts.zipCode,
		'service': service,
		'site': modForm.opts.quadLinkData.WebSiteName?.replace(/^www\./, '').replace(/^qa\./, ''),
		...quadLinkData,
		...partnerSourceID,
		'serviceSpecificAttributes': {
			...modForm.opts.serviceSpecificAttributes
		},
		'searchContext': {
			'searchContext': 'O&O Web Pre Submit',
			'landingPageUrl': window.location.href.split('#')[0],
			...activeExp
		}
	};

	// If `Match` parameter was passed in the URL, include it in the consent search data
	if (modForm.opts.getVars.Match) {
		consentSearchData.matchingAttributes = {
			'matchVendors': [modForm.opts.getVars.Match]
		};
	}

	if (JSON.stringify(consentSearchData) === modForm.opts.consentCaptureDetails) {
		return;
	}

	modForm.opts.consentCaptureDetails = JSON.stringify(consentSearchData);

	let response = {};
	const request = new XMLHttpRequest();
	request.open('POST', apiUrl);
	request.setRequestHeader('Content-Type', 'application/json');
	request.send(JSON.stringify(consentSearchData));
	Modalytics.heap('track', ['Consent Searches | Called']);
	request.addEventListener('load', function() {
		if (this.response) {
			response = { ...response, ...JSON.parse(this.response) };
			if (this.readyState === 4 && this.status === 200) {
				Modalytics.heap('track', ['Consent Searches | Successful Response', {
					...(response?.requestId && { requestId: response.requestId })
				}]);
				if (response.requestId) {
					modForm.opts.consentRequestId = response.requestId;
				}

				if (JSON.stringify(response)) {
					// if exclusive vendor is the only vendor returned along with modernize, we need to change the tcpa language
					if (response.data && response.data.length === 2) {
						const exclusiveVendors = Object.values(modForm.opts.eCommerceVendorKeys.exclusive).flat(Infinity);
						for (let i = 0; i < 2; i++) {
							if (exclusiveVendors.includes(String(response.data[i].vendorKey))) {
								isExclusiveMatch = true;
								modForm.tentativeAngiMatch = modForm.tentativeAngiMatch || modForm.opts.eCommerceVendorKeys.exclusive.angi.includes(response.data[i].vendorKey);
								const isTcpaModified = modifyTcpaForExclusiveVendors(response.data[i]);
								if (isTcpaModified) {
									window.Footer?.initModalLinks('.tcpa a[data-bind="modal-page"]');
									window.exclusiveTcpa = true;
									modForm.opts.exclusiveVendorId = response.data[i].vendorKey;
								}
							}
						}
					}

					// When exclusive tcpa is displayed, and if user decides to change form data which doesn't return exclusive anymore
					if (!isExclusiveMatch && window.exclusiveTcpa) {
						modForm.tentativeAngiMatch = false;
						window.exclusiveTcpa = false;
						modForm.opts.exclusiveVendorId = '';
						modForm.opts.tcpaCopy[0].innerHTML = modForm.opts.originalTcpa;
						Modalytics.heap('track', ['Modified TCPA Back to Original']);
						window.Footer?.initModalLinks('.tcpa a[data-bind="modal-page"]');
					}

					updateConsentHiddenFields();

					if (callback) {
						callback(response);
					}
				}
			} else {
				const error = `${this.status}: ${this.statusText}`,
					responseText = this.responseText;

				Modalytics.heap('track', ['Consent Searches | Failed', {
					error: error,
					response: responseText
				}]);
			}
		}
	});

	request.addEventListener('error', function() {
		console.error('Something went wrong!');
		Modalytics.heap('track', ['Consent Searches | Network Error']);
	});
}
